var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    { staticClass: "btn btn-light btn-sm", on: { click: _vm.onClick } },
    [_vm._v("\n    Documentation\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }